/* eslint-disable */

if (!customElements.get('bis-block')) {
  class BisBlock extends HTMLElement {
    constructor() {
      super();
      this.wrapper = this.parentElement
      this.productWrapper = this.closest('.product');
      this.variantPicker = this.productWrapper.querySelector('variant-picker')
      this.input = this.querySelector('input[type="email"]')
      this.button = this.querySelector('button')
      this.success = this.querySelector('.bis-block__success')

      this.button.addEventListener('click', this.registerEmail.bind(this))
      this.productWrapper.addEventListener('on:variant:change', this.check.bind(this))
      this.check()
    }

    check() {
      if (this.variantPicker?.variant?.available) this.wrapper.setAttribute('hidden', '')
      else this.wrapper.removeAttribute('hidden')
    }

    validateEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    }

    registerEmail() {
      try {
        const email = this.input.value || ''
        const validEmail = this.validateEmail(email)
        if(!validEmail) {
          alert('E-mail invalide')
          return;
        }

        klaviyo.push(['identify', {
          '$email': email
        }]);

        const payload = {
          "data": {
            "type": "back-in-stock-subscription",
            "attributes": {
              "profile": {
                "data": {
                    "type": "profile",
                    "attributes": { email }
                }
              },
              "channels": ["EMAIL"],
            },
            "relationships": {
              "variant": {
                "data": {
                  "type": "catalog-variant",
                  "id": "$custom:::$default:::bis-" + this.variantPicker.variant.id
                }
              }
            }
          }
        }
        const requestOptions = {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "revision":"2024-06-15"
          },
          body: JSON.stringify(payload),
        };
        fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=WXTEWA", requestOptions)
          .then(result => console.log(result))

        this.success.removeAttribute('hidden')
      } catch (error) {
        console.error(error)
        alert('Il y a eu une erreur')
      }
    }
  }

  customElements.define('bis-block', BisBlock);
}
